<ng-container *ngIf="regionState$ | async as state">
  <ng-container *ngIf="regionService.regionInActiveChannel(state); else NotInChannel">
    <ng-container *ngIf="regionService.isProductInSelectedRegion(state); else ProductNotInRegion">
      <div class="note">
        <fa-icon icon="check"></fa-icon>
        <span i18n="@@Checkout.PorductAvailableInArea.Note">
          The product is available in this delivery area.
        </span>
      </div>
      <div class="actions">
        <div class="region mat-body-1">
          <ng-container i18n="@@Checkout.DeliveryArea">Delivery Area</ng-container>
          :
          <strong>{{ state.region?.name }}</strong>
        </div>
        <button
          mat-flat-button
          color="primary"
          *ngIf="state.mode === 'add-to-cart'"
          (click)="regionService.addToCart(state)"
        >
          <ng-container i18n="@@Checkout.AddToBag">Add to bag</ng-container>
        </button>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #NotInChannel>
    <x-region-goto-channel></x-region-goto-channel>
  </ng-template>

  <ng-template #ProductNotInRegion>
    <div class="note not-available">
      <fa-icon icon="times" xIconSize="small"></fa-icon>
      <span i18n="@@Checkout.PorductNotAvailableInArea.Note">
        The product is not available in this delivery area. Continue to browse all the products
        available in this delivery area.
      </span>
    </div>
    <div class="actions">
      <div class="region mat-body-1">
        <ng-container i18n="@@Checkout.DeliveryArea">Delivery Area</ng-container>
        :
        <strong>{{ state.region?.name }}</strong>
      </div>
      <button mat-flat-button color="primary" (click)="regionService.confirm(state)">
        <ng-container i18n="@@CallToAction.Continue">Continue</ng-container>
      </button>
    </div>
  </ng-template>
</ng-container>
